import * as Immutable from 'immutable';
import {
  GET_ADMINMAINTENANCEMODE_REQUESTED,
  GET_ADMINMAINTENANCEMODE_COMPLETED,
  GET_ADMINMAINTENANCEMODE_FAILED,
  SET_ADMINMAINTENANCEMODE_REQUESTED,
  SET_ADMINMAINTENANCEMODE_COMPLETED,
  SET_ADMINMAINTENANCEMODE_FAILED,
} from '../../actions/adminmaintenancemode/types';

const schema = {
  // status: 'INIT', // INIT/OK/ERROR
  error: null,
  data: null,
  gettingdata: false,
  settingdata: false,
  gotdata: false,
  setdata: false,
};

const initialState = Immutable.Map(schema);

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADMINMAINTENANCEMODE_REQUESTED:
      return state
        .set('error', null)
        .set('data', null)
        .set('gettingdata', true);

    case GET_ADMINMAINTENANCEMODE_COMPLETED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('data', action.payload);

    case GET_ADMINMAINTENANCEMODE_FAILED:
      return state.set('error', action.payload);

    case SET_ADMINMAINTENANCEMODE_REQUESTED:
      return state
        .set('error', null)
        .set('data', null)
        .set('settingdata', true);

    case SET_ADMINMAINTENANCEMODE_COMPLETED:
      return state
        .set('error', null)
        .set('settingdata', false)
        .set('setdata', true)
        .set('data', action.payload);

    case SET_ADMINMAINTENANCEMODE_FAILED:
      return state.set('error', action.payload);

    default:
      return state;
  }
};

export { initialState };

export default reducer;
